var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-skeleton",
        { attrs: { animated: "" } },
        [
          _c("template", { slot: "template" }, [
            _c(
              "div",
              { staticClass: "item item1" },
              [
                _c("el-skeleton-item", {
                  staticClass: "circle",
                  attrs: { variant: "circle" },
                }),
                _c("el-skeleton-item", {
                  staticClass: "h1",
                  attrs: { variant: "h1" },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "item item2" },
              [
                _c("el-skeleton-item", {
                  staticClass: "circle",
                  attrs: { variant: "circle" },
                }),
                _c("el-skeleton-item", {
                  staticClass: "text",
                  attrs: { variant: "h1" },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "item item3" },
              [
                _c("el-skeleton-item", {
                  staticClass: "circle",
                  attrs: { variant: "circle" },
                }),
                _c("el-skeleton-item", {
                  staticClass: "h1",
                  attrs: { variant: "h1" },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "item item4" },
              [
                _c("el-skeleton-item", {
                  staticClass: "circle",
                  attrs: { variant: "circle" },
                }),
                _c("el-skeleton-item", {
                  staticClass: "text",
                  attrs: { variant: "h1" },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }